/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowphotocolor3Inputs */

const en_aiflowphotocolor3 = /** @type {(inputs: Aiflowphotocolor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colour`)
};

const de_aiflowphotocolor3 = /** @type {(inputs: Aiflowphotocolor3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbe`)
};

/**
* | output |
* | --- |
* | "Colour" |
*
* @param {Aiflowphotocolor3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowphotocolor3 = /** @type {((inputs?: Aiflowphotocolor3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowphotocolor3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowphotocolor3(inputs)
	return de_aiflowphotocolor3(inputs)
});
export { aiflowphotocolor3 as "aiFlowPhotoColor" }